import { useTranslation } from "react-i18next";
import { UpdateScreenSizeMetaForm } from "./UpdateScreenSizeMetaForm";
import { useSearchParams } from "react-router";
import { getScreenSizeDetails } from "@/sideEffects/api";
import { useQuery } from "@tanstack/react-query";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { ROUTES } from "@/constants/routeConstants";
import { LoadingSmall } from "@/components/LoadingSmall";
import { DeleteScreenSizeButton } from "./DeleteScreenSizeButton";
import { BaseFormLayout } from "@/pages/shared/BaseFormLayout";
import { useSelector } from "react-redux";
import { selectActiveFirm } from "@/store/appSelectors";

export const ScreenSizeDetailPage = () => {
  const { t } = useTranslation();
  const [queryParams] = useSearchParams();
  const screenSizeId = queryParams.get("Id");
  const activeFirm = useSelector(selectActiveFirm);

  const { data: playerScreenSizeDetails, isLoading } = useQuery({
    queryFn: () => getScreenSizeDetails(String(screenSizeId), String(activeFirm?.firmGuid)),
    queryKey: ["getScreenSizeDetails", screenSizeId],
  });

  const playerScreenSizeDetailsData = playerScreenSizeDetails?.data;

  useBreadcrumbs([
    {
      name: t("entities.screenSize"),
      path: ROUTES.SCREEN_SIZE,
    },
    {
      name: playerScreenSizeDetailsData
        ? `${t("common.entityDetail", { name: playerScreenSizeDetailsData?.name })}`
        : "...",
      path: ROUTES.SCREEN_SIZE_DETAIL,
    },
  ]);

  if (!playerScreenSizeDetailsData || isLoading) {
    return <LoadingSmall />;
  }

  return (
    <BaseFormLayout
      title={t("common.entityDetail", { name: playerScreenSizeDetailsData?.name })}
      rightContent={<DeleteScreenSizeButton screenSizeId={playerScreenSizeDetailsData.id} />}
    >
      <UpdateScreenSizeMetaForm playerScreenSizeDetails={playerScreenSizeDetailsData} />
    </BaseFormLayout>
  );
};
